


import recommend from '@/components/course/recommend.vue';
import collection from '@/components/course/collection.vue';
import comment from '@/components/comment.vue';



export default {
    components: { recommend, collection, comment },
    name: 'index',
    head() {
        // 优化seo：动态设置title，keywords 和 description
        return {
            title: this.source.video_find.title,
            meta: [
                {
                    name: "keywords",
                    content: this.source.video_find.title,
                },
                {
                    hid: 'description', name: 'names', content: this.source.video_find.title
                },
            ],
            script: [
                { src: 'https://www.youtube.com/iframe_api', defer: true }
            ],
        };
    },
    data() {
        return {
            source: [],
            recommendSource: [],//推荐视频数据
            id: '',
            youtubeLink: '',//youtube的视频链接
            dialogVisible: false,//分享的模态框
            locationHref: '',//当前页面链接
            dialogWidth: '20%'



        };
    },
    watch: {
        '$route.query'(newVal, oldVal) {
            if (
                newVal.collection_type_id !== oldVal.collection_type_id ||
                newVal.collection_id !== oldVal.collection_id
            ) {
                this.tutorialDetails()
            }
        }

    },
    async asyncData({ $global, query ,req ,route}) {

        const res = await $global.courseDetail({ collection_type_id: query.collection_type_id, collection_id: query.collection_id })
        let playerOptions = {
            playbackRates: [0.7, 1.0, 1.5, 2.0], //播放速度
            autoplay: false, //如果true,浏览器准备好时开始回放。
            muted: false, // 默认情况下将会消除任何音频。
            loop: false, // 导致视频一结束就重新开始。
            preload: 'auto', // 建议浏览器在<video>加载元素后是否应该开始下载视频数据。auto浏览器选择最佳行为,立即开始加载视频（如果浏览器支持）
            language: 'zh-CN',
            aspectRatio: '16:9', // 将播放器置于流畅模式，并在计算播放器的动态大小时使用该值。值应该代表一个比例 - 用冒号分隔的两个数字（例如"16:9"或"4:3"）
            fluid: true, // 当true时，Video.js player将拥有流体大小。换句话说，它将按比例缩放以适应其容器。
            sources: [
                { type: 'video/mp4', src: res.data.video_find.link }
            ],
            poster: res.data.video_find.thumb, //你的封面地址
            width: '100%',
            notSupportedMessage: 'This video is currently unavailable, please try again later', //允许覆盖Video.js无法播放媒体源时显示的默认信息。
        }
        const youtubeVideoId = res.data.video_find.source_type == 1 ? res.data.video_find.link.slice(res.data.video_find.link.lastIndexOf('/') + 1) : ''
        return { source: res.data, youtubeLink: youtubeVideoId ? `https://www.youtube.com/embed/${youtubeVideoId}` : '', youtubeVideoId, id: res.data.video_find.id, playerOptions, }

    },
    mounted() {
        this.locationHref = window.location.href

        this.dialogSize()
        /** hwtag埋点-阅读*/
        this.$track('content_viewed', {
            'content_id': this.source.collection_type_id,
            'content_type': 'courses',
            'author_id': '00001',
            'author':'XPPen',
            'current_view':this.source.video_find.hits
        });

        // 视频播放进度埋点
        this._progressTracked = {}
        this._lastPercentage = 0
        const player = this.$refs.videoPlayer?.player
        if (player) {
            player.on('timeupdate', () => {
                const duration = player.duration()
                if (!duration) return
                const percentage = Math.floor((player.currentTime() / duration) * 100)
                // seek 回退时重置前方进度点
                if (percentage < this._lastPercentage - 5) {
                    const milestones = [20, 40, 60, 80, 100]
                    milestones.forEach(m => { if (m > percentage) this._progressTracked[m] = false })
                }
                this._lastPercentage = percentage
                const milestones = [20, 40, 60, 80, 100]
                const milestone = milestones.find(m => percentage >= m && !this._progressTracked[m])
                if (milestone) {
                    this._progressTracked[milestone] = true
                    this.$track('video_play', {
                        action_type: 'progress',
                        content_id: String(this.source.video_find.id),
                        content_title: this.source.video_find.title,
                        progress_percentage: milestone,
                    })
                }
            })
        }

        // YouTube 视频播放进度埋点
        if (this.source.video_find.source_type == 1 && this.youtubeVideoId) {
            this._setupYoutubePlayer()
        }
    },
    beforeDestroy() {
        const player = this.$refs.videoPlayer?.player
        if (player) {
            player.off('timeupdate')
        }
        if (this._ytProgressTimer) {
            clearInterval(this._ytProgressTimer)
        }
        if (this._ytPlayer) {
            this._ytPlayer.destroy()
        }
    },
    // beforeMount(){
    //     if(!this.$store.state.isLogin){
    //         this.$jumpTerminus(4)
    //     }
    // },
    // computed: {
    //     player() {
    //         if (this.source.video_find.source_type == 1) {
    //             return this.$refs.youtube.player
    //         }

    //     }
    // },

    methods: {
        buildPlayerOptions(videoFind) {
            return {
                playbackRates: [0.7, 1.0, 1.5, 2.0], //播放速度
                autoplay: false, //如果true,浏览器准备好时开始回放。
                muted: false, // 默认情况下将会消除任何音频。
                loop: false, // 导致视频一结束就重新开始。
                preload: 'auto', // 建议浏览器在<video>加载元素后是否应该开始下载视频数据。auto浏览器选择最佳行为,立即开始加载视频（如果浏览器支持）
                language: 'zh-CN',
                aspectRatio: '16:9', // 将播放器置于流畅模式，并在计算播放器的动态大小时使用该值。值应该代表一个比例 - 用冒号分隔的两个数字（例如"16:9"或"4:3"）
                fluid: true, // 当true时，Video.js player将拥有流体大小。换句话说，它将按比例缩放以适应其容器。
                sources: [
                    { type: 'video/mp4', src: videoFind.link }
                ],
                poster: videoFind.thumb, //你的封面地址
                width: '100%',
                notSupportedMessage: 'This video is currently unavailable, please try again later', //允许覆盖Video.js无法播放媒体源时显示的默认信息。
            }
        },
        getYoutubeVideoId(link) {
            return link ? link.slice(link.lastIndexOf('/') + 1) : ''
        },
        async tutorialDetails() {
            //作品详情
            const res = await this.$global.courseDetail({ collection_type_id: this.$route.query.collection_type_id, collection_id: this.$route.query.collection_id })
            if (res.code == 200) {
                this.source = res.data
                this.id = res.data.video_find.id
                this.playerOptions = this.buildPlayerOptions(res.data.video_find)
                this.locationHref = window.location.href
                this.youtubeVideoId = res.data.video_find.source_type == 1 ? this.getYoutubeVideoId(res.data.video_find.link) : ''
                this.youtubeLink = this.youtubeVideoId ? `https://www.youtube.com/embed/${this.youtubeVideoId}` : ''
                this.resetVideoProgress()
                this.$nextTick(() => {
                    this.refreshYoutubePlayer()
                })
            }
        },
        resetVideoProgress() {
            this._progressTracked = {}
            this._lastPercentage = 0
            this._ytProgressTracked = {}
            this._ytLastPct = 0
            this._ytStarted = false
            clearInterval(this._ytProgressTimer)
        },
        refreshYoutubePlayer() {
            if (this._ytPlayer) {
                this._ytPlayer.destroy()
                this._ytPlayer = null
            }
            if (this.source.video_find.source_type == 1 && this.youtubeVideoId) {
                this._setupYoutubePlayer()
            }
        },
        async likeOperation() {
            //点赞 取消点赞
            // type 1是作品点赞、取消点赞 20是教程点赞、取消点赞 7作品评论点赞、取消点赞 8教程咨询评论点赞、取消点赞 21帖子点赞 取消点赞 22 帖子评论点赞 取消点赞
            let res = await this.$global.likeaction({ "relation_id": this.source.video_find.id, "type": "20" })
            if (res.code == 200) {
                this.source.video_find.is_like = res.data.hasClick
                this.tutorialDetails()
                this.$message({
                    showClose: true,
                    message: res.msg
                });
                if(this.source.video_find.is_like==1){
                    /** hwtag埋点-点赞*/
                    this.$track("content_liked", {
                        content_id: this.source.video_find.id,
                        content_type: 'courses',
                        author_id: '00001',
                        author: 'xppen',
                        current_like: this.source.video_find.like_num,
                    });
                }

            }

        },
        async collectOperation() {
            //收藏 取消收藏
            //type 1作品收藏 3资讯收藏 5活动收藏 9帖子收藏 10教程收藏
            //is_collect 0是收藏1取消收藏
            let res = await this.$global.do_collect({ "relation_id": this.source.video_find.id, "type": "10", "is_collect": this.source.video_find.is_collect })
            console.log(res, 'res')
            if (res.code == 200) {
                this.source.video_find.is_collect = !this.source.video_find.is_collect
                this.tutorialDetails()
                this.$message({
                    showClose: true,
                    message: res.msg
                });
                if(this.source.video_find.is_collect==1){
                    /** hwtag埋点-收藏*/
                    this.$track("content_collected", {
                        content_id: this.source.video_find.id,
                        content_type: 'courses',
                        author_id: '00001',
                        author: 'xppen',
                        current_collect: this.source.video_find.collect_num,
                    });
                }
            }

        },

        _setupYoutubePlayer() {
            const init = () => {
                try {
                    this._ytProgressTracked = {}
                    this._ytLastPct = 0
                    this._ytPlayer = new YT.Player('youtube-player', {
                        videoId: this.youtubeVideoId,
                        playerVars: { autoplay: 0, modestbranding: 1, rel: 0 },
                        events: {
                            onError: (e) => {
                                console.error('YouTube player error:', e.data)
                                clearInterval(this._ytProgressTimer)
                            },
                            onStateChange: (e) => {
                                // YT.PlayerState.PLAYING == 1
                                if (e.data === 1 && !this._ytStarted) {
                                    this._ytStarted = true
                                    this.$track('video_play', {
                                        action_type: 'start',
                                        content_id: String(this.source.video_find.id),
                                        content_title: this.source.video_find.title,
                                        progress_percentage: 0,
                                    })
                                }
                                if (e.data === 1) {
                                    clearInterval(this._ytProgressTimer)
                                    this._ytProgressTimer = setInterval(() => {
                                        try {
                                            const duration = this._ytPlayer.getDuration()
                                            if (!duration) return
                                            const pct = Math.floor((this._ytPlayer.getCurrentTime() / duration) * 100)
                                            // seek 回退时重置前方进度点
                                            if (pct < this._ytLastPct - 5) {
                                                ;[20, 40, 60, 80, 100].forEach(m => { if (m > pct) this._ytProgressTracked[m] = false })
                                            }
                                            this._ytLastPct = pct
                                            const milestone = [20, 40, 60, 80, 100].find(m => pct >= m && !this._ytProgressTracked[m])
                                            if (milestone) {
                                                this._ytProgressTracked[milestone] = true
                                                this.$track('video_play', {
                                                    action_type: 'progress',
                                                    content_id: String(this.source.video_find.id),
                                                    content_name: this.source.video_find.title,
                                                    progress_percentage: milestone,
                                                })
                                            }
                                        } catch (err) {
                                            console.error('YouTube progress tracking error:', err)
                                        }
                                    }, 1000)
                                }
                                // YT.PlayerState.PAUSED == 2, ENDED == 0
                                if (e.data === 2 || e.data === 0) {
                                    clearInterval(this._ytProgressTimer)
                                }
                                // 播放完成时补发100%进度埋点并重置
                                if (e.data === 0) {
                                    if (!this._ytProgressTracked[100]) {
                                        this._ytProgressTracked[100] = true
                                        this.$track('video_play', {
                                            action_type: 'progress',
                                            content_id: String(this.source.video_find.id),
                                            content_name: this.source.video_find.title,
                                            progress_percentage: 100,
                                        })
                                    }
                                    this._ytStarted = false
                                    this._ytProgressTracked = {}
                                    this._ytLastPct = 0
                                }
                            }
                        }
                    })
                } catch (err) {
                    console.error('YouTube player init error:', err)
                }
            }
            if (typeof YT !== 'undefined' && YT.Player) {
                init()
            } else {
                window.onYouTubeIframeAPIReady = init
            }
        },
        onPlayerPlay(player) {
            this.$track('video_play', {
                action_type: 'start',
                content_id: String(this.source.video_find.id),
                content_name: this.source.video_find.title,
                progress_percentage: 0,
            })
        },
        onPlayerPause(player) { },
        onPlayerEnded() {
            this._progressTracked = {}
        },
        onCopy() {
            this.$copyText(this.locationHref).then(
                e => {
                    console.log('复制成功：', e);
                },
                e => {
                    console.log('复制失败：', e);
                }

            )
            this.dialogVisible = false
        },
        shareExternalLink(type) {
            //1是分享到Facebook 2是分享到twitter
            switch (type) {
                case 1:
                    window.open(`http://www.facebook.com/sharer.php?u=${window.location.href}`);
                    break
                case 2:
                    window.open(`https://twitter.com/intent/tweet?url=${window.location.href}`);
                    break
            }
             /** hwtag埋点-分享*/
             this.$track("share", {
                content_id: this.source.video_find.id,
                content_type: 'courses',
                author_id: 'xppen',
                author: '00001',
                social_type: type == 2 ? "X" : "facebook",
            });

        },
        dialogSize() {
            //模态框尺寸
            document.body.clientWidth <= 768 ? this.dialogWidth = '90%' : document.body.clientWidth >= 768 && document.body.clientWidth <= 1660 ? this.dialogWidth = '35%' : this.dialogWidth = '20%'
            window.onresize = () => {
                document.body.clientWidth <= 768 ? this.dialogWidth = '90%' : document.body.clientWidth >= 768 && document.body.clientWidth <= 1660 ? this.dialogWidth = '35%' : this.dialogWidth = '20%'
            }
        }


    },
    computed: {
        player() {
            return this.$refs.videoPlayer.player
        }
    }



}
